export default __webpack_public_path__ + "static/media/icon-start-making-money.637710e2.svg";